import { Directive, HostListener, Input } from "@angular/core";
import { PureCloudPMModel } from "app/_models/pure-cloud-pm.model";
import { CedNotificationService } from "ced-ng-library";
import { environment } from "environments/environment";

const PFE_ORIGIN = environment.Services.myPureCloudApp;

@Directive({
    selector: '[pcDial]'
})
export class PureCloudDialDirective{
   
    @Input() pcDial = null; 
    constructor(private notificationService : CedNotificationService){}
    @HostListener('click') onClick() {
        if (this.pcDial == null || this.pcDial == ''){
            this.notificationService.error('Phone Number Incorrect');
        }else{
            let dialMessage = new PureCloudPMModel(); 
            dialMessage.number = this.pcDial;
            dialMessage.autoPlace = true; 
            dialMessage.type ='[PM] Dial';
            console.log(JSON.stringify(dialMessage));
            window.frames['phone'].contentWindow.postMessage(dialMessage, PFE_ORIGIN);

        }
        
    }
}